<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/inventory/index"> Manage Inventory  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{ alldata.relatedToProduct.P_code }} </h6>

            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

                  <button  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                 
            
                </div>





                <div class="card bdr-rad2 mt-1 shadow p-2  ">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Product Code</b></td>
                           <td>{{ alldata.relatedToProduct.P_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Product Description</b></td>
                           <td>{{ alldata.relatedToProduct.P_description  }}</td> 
                          </tr>
                          <tr>
                            <td><b>Inventory Location</b></td>
                           <td>Physical Stores</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Location No</b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Name </b></td>
                           <td>{{ alldata.relatedToProduct.relatedToSupplier.sup_name }}</td> 
                          </tr>
                          
                          
                         
                           
                        </tbody>
                 
                 
                      </table>


                </div>
                </div>


                     


                    <div class="card bdr-rad2 mt-1 shadow p-2 ">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Transaction</b></h6>

                               <div class="table-responsive"> 
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Transaction Date</th>
                              <th>Batch No.</th>
                              <th>Transaction No.</th>
                              <th>Received Qty</th>
                              <th>Issued Qty</th>
                              <th>Balance</th>
                           
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(sales_detail, index) in sales_details" :key="sales_detail.id_tansaction">
                              <td>{{ index + 1 }}</td>
                              <td>{{ sales_detail.transaction_date }}</td>
                            
                              <td>{{ sales_detail.relatedToInventory.I_batch_no }}</td>
                              <td>{{ sales_detail.transaction_no }}</td>
                              <td>{{ Number(sales_detail.received_qty).toFixed(0) }}</td>
                              <td>{{ Number(sales_detail.issues_qty).toFixed(0) }}</td>
                              <td>{{ Number(sales_detail.balance).toFixed(0) }}</td>
                             
                              </tr>
                            </tbody>

                          </table>
</div>

                        </div>
                    </div>






                    <div class="card bdr-rad2 mt-1 shadow p-2 ">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>


                        </div>
                    </div>



                    <div class="card bdr-rad2 mt-1 shadow p-2 ">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                  
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  
                    
                    </tr>
                  </tbody>

                </table>


             
                <br>
        
            

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3"   style="font-size: small;" class="form-control bdr-rad" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select bdr-rad" v-model="selectedOption">
                              <option  selected>Select....</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input type="date"  style="font-size: small;" class="form-control bdr-rad" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input   style="font-size: small;" class="form-control bdr-rad" >
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button   class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Add CRM Note</button>
                </div>
                </div>

            </div>
        </div>







   

<br><br>





                




                </div>
                </div>
          
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSinvoice()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            total:{},
            alldata:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
            sinvo:{},
            details:[],
            trans:[],
            rec_dets:[],
            sales_details:[],
     
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
          async Update(){
        this.$router.push('/ssalesorder/update?id='+this.id);
      },

            async loadSinvoice() {
        console.log("Amila");
      
      try {
        const { data} = await  axios.get('/iinventory/indexbyproduct?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
          this.alldata = data.alldata
          this.sales_details = data.sales_details
        //   this.sinvo = data.sinvoice
        //    this.details = data.details
        //    this.total = data.total
        //    this.rec_dets = data.rec_dets
       
        
      } catch (error) {
        console.log(error.response);
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>